import React from 'react';
import { Card } from '../ui/Card';
import { AlertCircle, XCircle } from 'lucide-react';
export function Problem() {
  return <section className="py-12 md:py-16 bg-charcoal-900/50" data-id="element-143">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-144">
        {/* Opening Lead */}
        <div className="text-center mb-16 space-y-6" data-id="element-145">
          <p className="text-xl md:text-2xl font-serif text-cream-100 italic" data-id="element-146">
            "No es que ya no se quieran. Es que la casa se volvió una empresa."
          </p>
          <div className="w-16 h-px bg-amber-400/30 mx-auto" data-id="element-147" />
          <p className="text-cream-200/80 leading-relaxed text-lg" data-id="element-148">
            Pendientes. Cuentas. Niños. Trabajo. Cansancio.
            <br data-id="element-149" />Y un día te das cuenta de lo más raro:{' '}
            <strong className="text-cream-100 font-medium" data-id="element-150">
              duermes al lado de alguien… y te sientes solo/a.
            </strong>
          </p>
        </div>

        {/* The Problem Cards */}
        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-151">
          <Card className="h-full" data-id="element-152">
            <h3 className="text-xl font-serif text-amber-400 mb-4 flex items-center gap-2" data-id="element-153">
              <AlertCircle className="w-5 h-5" data-id="element-154" />
              La Verdad Incómoda
            </h3>
            <p className="text-cream-200/80 mb-4" data-id="element-155">
              La mayoría de matrimonios no se rompen por una gran tragedia. Se
              rompen por algo más pequeño y más cruel:
            </p>
            <p className="text-lg font-medium text-cream-100 border-l-2 border-amber-400/50 pl-4 italic" data-id="element-156">
              Vivir juntos y dejar de encontrarse.
            </p>
          </Card>

          <Card className="h-full" data-id="element-157">
            <h3 className="text-xl font-serif text-amber-400 mb-4 flex items-center gap-2" data-id="element-158">
              <XCircle className="w-5 h-5" data-id="element-159" />
              Por qué "hablar" falla
            </h3>
            <p className="text-cream-200/80 mb-4" data-id="element-160">
              Cuando el clima está roto, cualquier tema se siente como ataque.
            </p>
            <ul className="space-y-2 text-cream-200/70 text-sm" data-id="element-161">
              <li className="flex items-start gap-2" data-id="element-162">
                <span className="text-red-400 mt-1" data-id="element-163">×</span> "Necesitamos
                hablar" = "Estás fallando"
              </li>
              <li className="flex items-start gap-2" data-id="element-164">
                <span className="text-red-400 mt-1" data-id="element-165">×</span> "Nunca haces..." =
                Defensa inmediata
              </li>
              <li className="flex items-start gap-2" data-id="element-166">
                <span className="text-red-400 mt-1" data-id="element-167">×</span> "Yo solo quiero..."
                = Exigencia
              </li>
            </ul>
          </Card>
        </div>

        {/* Symptoms List */}
        <div className="bg-charcoal-800 rounded-xl p-8 border border-charcoal-700" data-id="element-168">
          <h3 className="text-2xl font-serif text-center mb-8" data-id="element-169">
            Señales de "Modo Roomies"
          </h3>
          <div className="grid sm:grid-cols-2 gap-y-4 gap-x-8" data-id="element-170">
            {['Hablan casi solo de logística', 'Se tocan poco o nada', 'La cama se volvió costumbre o distancia', 'Cuando intentan hablar, explota o se congela', 'Extrañas a tu pareja… teniéndola al lado'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-171">
                <div className="w-1.5 h-1.5 rounded-full bg-amber-400 flex-shrink-0" data-id="element-172" />
                <span className="text-cream-200/90" data-id="element-173">{item}</span>
              </div>)}
          </div>
          <p className="text-center mt-8 text-cream-200/60 italic text-sm" data-id="element-174">
            Si esto te duele, no estás exagerando. Estás viendo la realidad.
          </p>
        </div>
      </div>
    </section>;
}